// Dataset id → display name. Shared by every surface that shows a dataset to the
// user (thread cart + Makeup screen, Audiences inventory, Distributions) so the
// same id always reads as the same friendly name. Framework-agnostic by the
// lib/** layer rule.
export const datasetIdToName: Record<string, string> = {
    alliant: 'Alliant',
    analyticsiq: 'AnalyticsIQ',
    online_behavioral_segments: 'Sovrn',
    cpg: 'Above Data CPG',
    credit_card_transactions: 'Credit Card Transactions',
    user_demographics_intent: 'User Demographics and Intent',
    alwayson: 'Always On Data',
}

// Dataset id → total reachable universe (count of addressable US users in the
// dataset). PLACEHOLDER stub: the backend `BaseDataset` doesn't yet expose a
// universe size, so these are approximate US-reach figures used to give the
// modeling screen a denominator (seed coverage, % of pool). Replace with a real
// per-dataset count once the API surfaces it.
//
// Figures calibrated to each provider's published US reach (Jun 2026):
//   alliant ~280M; analyticsiq ~263M; Credit Card Transactions
//   ~140M cards; sovrn ~200M US-addressable; the demographic universe ~497M.
//   cpg_transactions is a known internal figure (18M). cpg / alwayson have no public
//   person-count, so they stay rough estimates.
export const datasetUniverseSize: Record<string, number> = {
    alliant: 280_000_000,
    analyticsiq: 263_000_000,
    online_behavioral_segments: 200_000_000,
    cpg: 230_000_000,
    credit_card_transactions: 140_000_000,
    user_demographics_intent: 497_000_000,
    alwayson: 250_000_000,
    cpg_transactions: 18_000_000,
}
